




































































import { Component, Prop, Vue, Emit  } from 'vue-property-decorator';
import {IAllowBlockDescription, IAllowBlockList} from '../services/models/AllowBlockList';

@Component({
})
// @ts-ignore
export default class AllowBlockListComponent extends Vue {
    // @ts-ignore
    @Prop() private allowBlockList: IAllowBlockList;

    @Emit()
    private save(allowBlockList: IAllowBlockList) {
        // dummy
    }

    @Emit()
    private remove(allowBlockList: IAllowBlockList): void {
        // @ts-ignore
    }

    private get Id(): string {
        return this.allowBlockList.id;
    }

    private get Name(): string {
        return this.allowBlockList.name;
    }

    private get BlockDisabled(): string {
        if (this.allowBlockList.allow.length > 0) {
            return 'disabled';
        }

        return '';
    }

    private AllowDescription(index: number) {
        if (index < this.allowBlockList.descriptions.length) {
            return this.allowBlockList.descriptions[index].allow;
        }

        return '';
    }

    private BlockDescription(index: number) {
        if (index < this.allowBlockList.descriptions.length) {
            return this.allowBlockList.descriptions[index].block;
        }

        return '';
    }

    private removeAccessBlockList() {
        this.$bvModal.msgBoxConfirm(`Delete ${this.Name}`, {
                title: 'Delete Access/Block-list',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'YES',
                cancelTitle: 'NO',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true,
            })
            .then((value) => {
                if (value) {
                    this.remove(this.allowBlockList);
                }
            })
            .catch((err) => {
                // An error occurred
            });
    }


    private updateAllowAddress(newValue: string, index: number = 0): void {
        // @ts-ignore
        Vue.set(
            this.allowBlockList.allow,
            index,
            newValue,
        );
    }

    private updateAllowAddressDescription(newValue: string, index: number = 0): void {
        let oldValue: IAllowBlockDescription = {
            allow: newValue,
            block: '',
        };

        if (this.allowBlockList.descriptions.length <= index) {
            for (let i: number = this.allowBlockList.descriptions.length; i <= index; i++) {
                // @ts-ignore
                Vue.set(
                    this.allowBlockList.descriptions,
                    i,
                    {
                        allow: '',
                        block: '',
                    },
                );
            }
        } else {
            oldValue = this.allowBlockList.descriptions[index];
            oldValue.allow = newValue;
        }

        // @ts-ignore
        Vue.set(
            this.allowBlockList.descriptions,
            index,
            oldValue,
        );
    }

    private updateBlockAddress(newValue: string, index: number = 0): void {
        // @ts-ignore
        Vue.set(
            this.allowBlockList.block,
            index,
            newValue,
        );
    }
    private updateBlockAddressDescription(newValue: string, index: number = 0): void {
        let oldValue: IAllowBlockDescription = {
            allow: '',
            block: newValue,
        };

        if (this.allowBlockList.descriptions.length < index) {
            for (let i: number = this.allowBlockList.descriptions.length; i < index; i++) {
                // @ts-ignore
                Vue.set(
                    this.allowBlockList.descriptions,
                    i,
                    {
                        allow: '',
                        block: '',
                    },
                );
            }
        } else {
            oldValue = this.allowBlockList.descriptions[index];
            oldValue.block = newValue;
        }

        // @ts-ignore
        Vue.set(
            this.allowBlockList.descriptions,
            index,
            oldValue,
        );
    }

    private nameChanged(newValue: string): void {
        Vue.set(this.allowBlockList, 'name', newValue);
    }

    private addAllowAddress() {
        Vue.set(this.allowBlockList.allow, this.allowBlockList.allow.length, '');
    }

    private removeAllowAddress(index: number) {
        Vue.delete(this.allowBlockList.allow, index);
    }

    private addBlockAddress() {
        if (this.BlockDisabled === '') {
            Vue.set(this.allowBlockList.block, this.allowBlockList.block.length, '');
        }
    }

    private removeBlockAddress(index: number) {
        if (this.BlockDisabled === '') {
            Vue.delete(this.allowBlockList.block, index);
        }
    }

    private saveAllowBlockList() {
        this.save(this.allowBlockList);
    }
}
